import {ENDPOINT_RULES} from 'common/endpoints';
import {CALL_API} from 'redux-api-middleware';
import {
  API_RULES_GET_REQUEST,
  API_RULES_GET_SUCCESS,
  API_RULES_GET_FAILURE,
} from 'common/types';
import {commonJwtHeader} from 'common/utils';

export default {
  getRules: (token, grantId, config, subGrantId) => {
    let encodedRules = encodeURI(JSON.stringify(config));
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_RULES}?grantId=${grantId}&rules=${encodedRules}${
          subGrantId ? `&subGrantId=${subGrantId}` : ''
        }`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_RULES_GET_REQUEST, API_RULES_GET_SUCCESS, API_RULES_GET_FAILURE],
      },
    };
  },
  //Remove the toggle once the toggles are in PROD
  getRulesByGrant: (token, grantId, hasDunsOrUei, config) => {
    let encodedRules = encodeURI(JSON.stringify(config));
    return {
      [CALL_API]: {
        endpoint: `${ENDPOINT_RULES}?hasDunsOrUei=${hasDunsOrUei}&grantId=${grantId}&rules=${encodedRules}`,
        headers: commonJwtHeader(),
        method: 'GET',
        types: [API_RULES_GET_REQUEST, API_RULES_GET_SUCCESS, API_RULES_GET_FAILURE],
      },
    };
  },
};
